import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.showModal()
    document.body.classList.add("modal-open")
  }

  disconnect() {
    document.body.classList.remove("modal-open")
  }

  close(event) {
    if (event.target === this.element) {
      this.element.close()
    }
  }

  closeButton(event) {
    event.preventDefault()
    this.element.close()
  }

  closeWithKeyboard(event) {
    if (event.code === "Escape") {
      this.element.close()
    }
  }

  handleSubmit(event) {
    if (event.detail.success) {
      // Cerrar el dialog programáticamente cuando la operación sea exitosa
      this.element.close()
    }
  }
}
